import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgStarMedal = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 25,
	viewBox: "0 0 24 25",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M16.836 22.2769V19.5224C16.836 19.2486 16.614 19.0266 16.3402 19.0266H9.16318C8.88939 19.0266 8.66744 19.2486 8.66744 19.5224V22.2769M6.936 22.2766H18.5618M18.3613 16.9345L18.633 17.2327M7.13766 16.9345L6.86596 17.2327M10.1642 4.14563L12.8984 5.86198C13.1684 6.03077 13.5045 6.05578 13.797 5.92979L16.8007 4.64839C17.2842 4.43496 17.8489 4.65489 18.0623 5.13833C18.1493 5.33611 18.167 5.55842 18.1119 5.76761L17.2812 8.90118C17.1984 9.2077 17.274 9.53445 17.4839 9.77313L19.6037 12.195C19.9517 12.6031 19.9024 13.2158 19.4943 13.5638C19.3333 13.7005 19.1325 13.7809 18.9218 13.7934L15.6767 14.0146C15.3573 14.0368 15.0689 14.212 14.9022 14.4854L13.2359 18.3543C12.962 18.815 12.3666 18.966 11.906 18.6922C11.7243 18.5834 11.5831 18.4196 11.5037 18.2237L10.3042 14.1381C10.1887 13.8431 9.93336 13.6255 9.62381 13.5575L6.4575 12.8539C5.94219 12.738 5.61758 12.2269 5.73303 11.7109C5.78046 11.4999 5.89849 11.3108 6.06737 11.1748L8.5875 9.09785C8.83395 8.89622 8.96645 8.58629 8.94156 8.26847L8.67786 5.04925C8.64097 4.50936 9.04879 4.04223 9.58868 4.00533C9.79001 3.99114 9.99089 4.04012 10.1642 4.14563Z",
		stroke: "#888EAA",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgStarMedal;
